import Vue from "vue";
import { store } from "../store/store.js";
import Router from "vue-router";

import LoginPage from "@/views/Auth/Login";
import DashboardMain from "@/views/Dashboard/Main";

//Edit Profile
const EditProfileMain = () => import("@/views/Auth/Main");
import EditProfile from "@/views/Auth/EditProfile";

//Error Pages
import NotFound from "@/views/Error/SmallNotFound";
import PageNotFound from "@/views/Error/PageNotFound";

const HighlightsMain = () => import("@/views/Dashboard/Highlights/Main");
import Highlights from "@/views/Dashboard/Highlights/Highlights";
import HighlightsQRJourney from "@/views/Dashboard/Highlights/HighlightsQRJourney";
import HighlightsCounterfeitLocation from "@/views/Dashboard/Highlights/CounterfeitLocation";
import HighlightsFrequentlyScannedProductMap from "@/views/Dashboard/Highlights/FrequentlyScannedProductMap";

const ActivitiesMain = () => import("@/views/Dashboard/Activities/Main");
import ActivitySummary from "@/views/Dashboard/Activities/ActivitySummary";
import LatestActivity from "@/views/Dashboard/Activities/LatestActivity";
import CustomerReport from "@/views/Dashboard/Activities/CustomerReport";
import QRManagement from "@/views/Dashboard/Activities/QRManagement";
import SuspectReport from "@/views/Dashboard/Activities/SuspectReport";
import ReportSuspect from "@/views/Dashboard/Activities/ReportSuspect";
import QrCode from "@/views/Dashboard/Activities/QrCode";
import CrossClient from "@/views/Auth/CrossClient";

const DomainDetectionMain = () => import("@/views/Dashboard/DomainDetection/Main");
import DomainDetectionSummary from "@/views/Dashboard/DomainDetection/DomainDetectionSummary";
const ReviewDomain = () => import("@/views/Dashboard/DomainDetection/ReviewDomain");
const ReviewDomainDetail = () => import("@/views/Dashboard/DomainDetection/ReviewDomainDetail");
const DomainDistribution = () => import("@/views/Dashboard/DomainDetection/DomainDistribution");

const UserManagementMain = () =>
  import("@/views/Dashboard/UserManagement/Main");
import UserManagement from "@/views/Dashboard/UserManagement/UserManagement";
import CUUser from "@/views/Dashboard/UserManagement/CUUser";

const AppPartMakerMain = () => import("@/views/Dashboard/AppPartMaker/Main");
import AppPartMaker from "@/views/Dashboard/AppPartMaker/AppPartMaker";
import CUPart from "@/views/Dashboard/AppPartMaker/CUPart";

// import EditUser from '@/views/Dashboard/UserManagement/children/EditUser'

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    //Login Path
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/login",
      name: "Login",
      component: LoginPage,
      meta: {
        requiresAuth: false,
      },
    },

    {
      path: "/cross-client",
      name: "Cross Client",
      component: CrossClient,
      meta: {
        requiresAuth: false,
      },
    },

    //Edit Profile
    {
      path: "",
      component: DashboardMain,
      children: [
        {
          path: "/edit-profile",
          name: "EditProfile",
          component: EditProfile,
          meta: {
            requiresAuth: true,
            sidebar: true,
          },
        },
      ],
    },

    //Dashboard Start
    {
      path: "/dashboard",
      component: DashboardMain,
      children: [
        //Default Fallback
        {
          path: "",
          name: "Dashboard",
          component: NotFound,
        },

        {
          path: "activities",
          name: "Activities",
          component: ActivitiesMain,
          children: [
            {
              path: "activity-summary",
              name: "ActivitySummary",
              component: ActivitySummary,
            },
            {
              path: "customer-report",
              name: "CustomerReport",
              component: CustomerReport,
            },
            {
              path: "suspect-report",
              name: "SuspectReport",
              component: SuspectReport,
            },
            {
              path: "report-suspect",
              name: "ReportSuspect",
              component: ReportSuspect,
            },
            {
              path: "qr-code",
              name: "QrCode",
              component: QrCode,
            },
            {
              path: "latest-activity",
              name: "LatestActivity",
              component: LatestActivity,
            },
            {
              path: "qr-management",
              name: "QRManagement",
              component: QRManagement,
            },
          ],
        },

        {
          path: "highlights",
          component: HighlightsMain,
          children: [
            {
              path: "",
              name: "Highlights",
              component: Highlights,
            },
            {
              path: "qr-journey",
              name: "HighlightsQRJourney",
              component: HighlightsQRJourney,
            },
            {
              path: "counterfeit-location",
              name: "HighlightsCounterfeitLocation",
              component: HighlightsCounterfeitLocation,
            },
            {
              path: "frequently-scanned-product-map",
              name: "HighlightsFrequentlyScannedProductMap",
              component: HighlightsFrequentlyScannedProductMap,
            },
          ],
        },

        {
          path: "user-management",
          component: UserManagementMain,
          children: [
            {
              path: "",
              name: "UserManagement",
              component: UserManagement,
            },
            {
              path: "create",
              name: "CUser",
              component: CUUser,
            },
            {
              path: "edit",
              name: "UUser",
              component: CUUser,
            },
          ],
        },

        // Domain Detection
        {
          path: "domain-detection",
          component: DomainDetectionMain,
          children: [
            {
              path: "summary",
              name: "DomainDetectionSummary",
              component: DomainDetectionSummary,
            },
            {
              path: "review-domain",
              name: "ReviewDomain",
              component: ReviewDomain,
              meta: {
                menu: "Domain Detection",
                module: "Review Domain",
              },
            },
            {
              path: "review-domain/:domain_id",
              name: "ReviewDomainDetail",
              component: ReviewDomainDetail,
              meta: {
                menu: "Domain Detection",
                module: "Review Domain Detail",
              },
            },
            {
              path: "domain-distribution",
              name: "DomainDistribution",
              component: DomainDistribution,
              meta: {
                menu: "Domain Detection",
                module: "Domain Distribution",
              },
            },
          ],
        },

        // Part Maker App
        {
          path: "part-maker-app",
          component: AppPartMakerMain,
          children: [
            {
              path: "",
              name: "AppPartMaker",
              component: AppPartMaker,
            },
            {
              path: "create",
              name: "CPart",
              component: CUPart,
            },
            {
              path: "edit",
              name: "UPart",
              component: CUPart,
            },
          ],
        },
      ],
      meta: {
        requiresAuth: true,
      },
    },

    //Error 404 Page Not Found
    {
      path: "*",
      component: PageNotFound,
      meta: {
        requiresAuth: false,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const tokenExpired = () => {
    const dateExpired = localStorage.getItem("date_expired");
    if (!dateExpired) return true;
    return new Date(dateExpired) < new Date();
  };
  if ((to.path === "/login" || to.path === "/") && !tokenExpired()) {
    return next("/dashboard/highlights");
  }

  if (requiresAuth && tokenExpired()) {
    return next("/login");
  }

  // Otherwise, proceed as normal
  next();
});

export default router;
